import { render, staticRenderFns } from "./showmore-product.vue?vue&type=template&id=5547601a&scoped=true&"
import script from "./showmore-product.vue?vue&type=script&lang=js&"
export * from "./showmore-product.vue?vue&type=script&lang=js&"
import style0 from "./showmore-product.vue?vue&type=style&index=0&id=5547601a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5547601a",
  null
  
)

export default component.exports